module.exports = __webpack_public_path__ + "img/profile-user.5eac940b.svg";